var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button toggle-button",class:{ 'is-primary': _vm.active },on:{"click":function($event){$event.preventDefault();return _vm.setValue()}}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5598731f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/toggle-buttons/toggleButton.vue
// module id = 494
// module chunks = 2